import React from "react";
import { Link } from "react-router-dom";

const FormSkip = (props) => {
  return props.hasSkip ? (
    <Link
      to="/dashboard"
      onClick={(e) => props.handleSkipButton(e)}
      className="skip-link"
    >
      Skip for now
    </Link>
  ) : null;
};

export default FormSkip;
